import { render, staticRenderFns } from "./CampaignTable.vue?vue&type=template&id=253f2606&scoped=true&"
import script from "./CampaignTable.vue?vue&type=script&lang=ts&"
export * from "./CampaignTable.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignTable.vue?vue&type=style&index=0&id=253f2606&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253f2606",
  null
  
)

export default component.exports